// Message-request VOCABULARY — the single source for intents + origins (keys,
// labels, pill colours). Kept axios-free (no service/api import) so pure
// consumers (chat intent filter, chips, tests) can use it without dragging the
// HTTP client into their module graph. messageRequestApi re-exports all of this
// unchanged, so existing importers keep working.

// COPY_DECK 1-legend + DESIGN_FRAME_INVENTORY intent colours.
// `key` = backend enum value; `label` = pill/dropdown title; `filterLabel` =
// short filter-chip word; `desc` = dropdown subtitle; `dot`/`pillBg`/`pillText`
// = colours.
export const MESSAGE_REQUEST_INTENTS = [
  {
    key: "player_opportunity",
    label: "Player Opportunity",
    filterLabel: "Player Opportunity",
    desc: "Propose a player for a concrete need",
    pillBg: "#EAF2FF",
    pillText: "#1466D8",
    dot: "#2283FF",
  },
  {
    key: "discuss_player",
    label: "Discuss about Player",
    filterLabel: "Discuss about Player",
    desc: "Talk about a specific player's situation",
    pillBg: "#F4F0FF",
    pillText: "#6941C6",
    dot: "#6941C6",
  },
  {
    key: "networking",
    label: "Networking",
    filterLabel: "Networking",
    desc: "Introduce yourself. No deal on the table yet",
    pillBg: "#E5F5F6",
    pillText: "#0E7C86",
    dot: "#0E7C86",
  },
  {
    // Bible D11 canonical wording is "Partnership" (not "Partnership Request") —
    // Lead decree 2 (Bibel schlägt Design-Text, AMBIGUITÄT-8 resolved).
    key: "partnership",
    label: "Partnership",
    filterLabel: "Partnership",
    desc: "Propose a working relationship between agencies",
    pillBg: "#EEF0FF",
    pillText: "#444CE7",
    dot: "#444CE7",
  },
  {
    key: "manual",
    label: "Manual",
    filterLabel: "Manual",
    desc: "Write your own intent in a few words",
    pillBg: "#F2F4F7",
    pillText: "#475467",
    dot: "#475467",
  },
];

export const MESSAGE_REQUEST_INTENT_BY_KEY = MESSAGE_REQUEST_INTENTS.reduce(
  (acc, it) => {
    acc[it.key] = it;
    return acc;
  },
  {},
);

// Origin tags are SYSTEM-SET. `tagLabel` = verbatim card tag; `filterLabel` =
// the ORIGIN segmented-control label.
export const MESSAGE_REQUEST_ORIGINS = [
  { key: "last_minute", tagLabel: "via Last Minute", filterLabel: "Last Minute" },
  { key: "agent_requests", tagLabel: "via Agent Requests", filterLabel: "Agent Req." },
  { key: "direct", tagLabel: "Direct", filterLabel: "Direct" },
];

export const MESSAGE_REQUEST_ORIGIN_BY_KEY = MESSAGE_REQUEST_ORIGINS.reduce(
  (acc, it) => {
    acc[it.key] = it;
    return acc;
  },
  {},
);

// Max open requests before the 24h cooldown (design 1r).
export const MESSAGE_REQUEST_DEFAULT_CAP = 20;
